import { Injectable } from "@angular/core";
import { AbstractService } from "../commons/abstract.service";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { Timeline } from "../models/timeline-attendance.model";
import { TimelineTypeEnum } from "../models/enum/timeline.types.enum";

@Injectable({ providedIn: 'root' })
export class TimelineService extends AbstractService<Timeline> {

  constructor(private http: HttpClient) {
    super(http);
  }

  getURLBase(): string {
    return '/timeline';
  }

  preCreate(obj: Timeline): void {
    delete obj?._id;
  }

  preUpdate(obj: Timeline): void {
  }

  getTimeline(id: string, type: TimelineTypeEnum): Observable<Timeline[]> {
    return super.get(`/${type}/${id}`);
  }
}
